import { Box, styled } from '@mui/material';

export const SectionContainer = styled('section')(() => ({
  width: `100%`,
  minHeight: `calc(100vh - 50px)`,

  '@media screen and (min-width: 1920px)': {
    minHeight: `calc(100vh - 58px)`,
  },

  '@media screen and (max-width: 1280px)': {
    minHeight: `calc(100vh - 48px)`,
  },

  '@media screen and (max-width: 640px)': {
    minHeight: `100vh`,
  },

  position: 'relative',
}));

export const SectionContent = styled(Box)(() => ({
  width: '100%',
  height: '100%',

  position: 'relative',
  zIndex: 1,
}));
